export default {
  empresas: [],
  empresaDNA: {},
  filtros: {
    perPage: 20,
    page: 1,
    termo: '',
    cnpj: '',
    nomeEmpresa: '',
    endereco: '',
  },
  campos: {
    nomeEmpresa: 'nomeEmpresa',
    cnpj: 'cnpj',
    responsavelComercial: 'responsavelComercial',
    responsavelOperacional: 'responsavelOperacional',
    assistente: 'assistente',
    endereco: 'endereco',
  },
  colDefault: '',
  directionDefault: '',
  colunasEmpresas: [
    {
      headerName: 'nomeEmpresa',
      field: 'nomeEmpresa',
      filter: 'TextFilter',
      filterParams: {
        module: 'empresas',
        fetch: 'listarEmpresas',
        colDef: {
          field: 'nomeEmpresa',
        },
      },
      valueFormatter: ({ data }) => ((data.nomeEmpresa) ? data.nomeEmpresa : 'N/I'),
      sortable: true,
    },
    {
      headerName: 'CNPJ',
      field: 'cnpj',
      filter: 'TextFilter',
      filterParams: {
        module: 'empresas',
        fetch: 'listarEmpresas',
        colDef: {
          field: 'cnpj',
        },
      },
      valueFormatter: ({ data }) => ((data.cnpj) ? data.cnpj : 'N/I'),
      sortable: true,
      maxWidth: 200,
    },
    {
      headerName: 'responsavelComercial',
      field: 'responsavelComercial',
      filter: 'TextFilter',
      filterParams: {
        module: 'empresas',
        fetch: 'listarEmpresas',
        colDef: {
          field: 'responsavelComercial',
        },
      },
      valueFormatter: ({ data }) => ((data.responsavelComercial) ? data.responsavelComercial : 'N/I'),
      sortable: true,
    },
    {
      headerName: 'responsavelOperacional',
      field: 'responsavelOperacional',
      filter: 'TextFilter',
      filterParams: {
        module: 'empresas',
        fetch: 'listarEmpresas',
        colDef: {
          field: 'responsavelOperacional',
        },
      },
      valueFormatter: ({ data }) => ((data.responsavelOperacional) ? data.responsavelOperacional : 'N/I'),
      sortable: true,
    },
    {
      headerName: 'assistente',
      field: 'assistente',
      filter: 'TextFilter',
      filterParams: {
        module: 'empresas',
        fetch: 'listarEmpresas',
        colDef: {
          field: 'assistente',
        },
      },
      valueFormatter: ({ data }) => ((data.assistente) ? data.assistente : 'N/I'),
      sortable: true,
    },
    {
      headerName: 'localizacao',
      field: 'endereco',
      filter: 'TextFilter',
      filterParams: {
        module: 'empresas',
        fetch: 'listarEmpresas',
        colDef: {
          field: 'endereco',
        },
      },
      valueFormatter: ({ data }) => ((data.endereco) ? data.endereco : 'N/I'),
      sortable: true,
    },
    {
      headerName: 'Ações',
      field: 'acoes',
      cellRenderer: 'CellAcoes',
      maxWidth: 120,
    },
  ],
  responsaveisComex: [],
  responsaveisExecutivos: [],
};
